// Upholstery Type core
export function upholsteryTypeCore() {
  const endpoint = '/upholsteries/types';
  const detailId = 'upholsteryTypeId';

  const getDetailId = (data = null) => {
    if (!data) {
      return;
    }

    if (Array.isArray(data)) {
      return data[0][detailId];
    }

    return data[detailId];
  };

  return {
    endpoint,
    detailId,
    getDetailId: getDetailId
  };
}

// Upholstery Type filter
export function upholsteryTypeFilter() {
  // Get rows
  const getRows = (data) => {
    const rows = [];

    data.forEach((row, i) => {
      // Text/numeric values
      rows[i] = {
        value: row.upholsteryTypeId
      };

      // Object values
      const objects = {
        label: row.upholsteryTypeDescription
      };

      // Get the text/value from the default culture
      Object.entries(objects).forEach(([j, prop]) => {
        prop.translations.forEach((culture, k) => {
          if (culture.defaultCulture === true) {
            rows[i][j] = culture.text;
          }
        });
      });
    });

    return rows;
  };

  return {
    getRows: getRows
  };
}
